// this file is autogenerated and should not be modified

import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "",
      "fill-rule": "nonzero",
      d: "M8.004 6.59L14.302.293a1 1 0 0 1 1.414 1.414L9.419 8.004l6.297 6.298a1 1 0 0 1-1.414 1.414L8.004 9.419l-6.297 6.297a1 1 0 1 1-1.414-1.414L6.59 8.004.293 1.707A1 1 0 1 1 1.707.293L8.004 6.59z"
    }, null, -1)
  ])))
}

export default render;